import {api} from './api';

export const getDepthApi = (plataforma: string | null, starttime: string, endtime: string) => {
    return api.get('daily_depths/', {params:{plataforma, starttime, endtime}}).then(res => res.data)
}